module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('h1', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center",
      "position": "relative"
    }
  }, [_vm._v("\n    System Settings\n    "), _c('button', {
    staticClass: "refresh-button",
    attrs: {
      "disabled": _vm.loading,
      "title": "Refresh"
    },
    on: {
      "click": _vm.loadSystemStats
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 4v6h6",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 20v-6h-6",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "2rem"
    }
  }, [_c('p', [_vm._v("Loading system information...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "2rem",
      "color": "red"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "margin-top": "0.5rem"
    },
    on: {
      "click": _vm.loadSystemStats
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.error && _vm.systemStats) ? _c('div', [_c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("CPU Information")]), _vm._v(" "), _c('span', {
    staticClass: "last-updated"
  }, [_vm._v("Last updated: " + _vm._s(_vm.formatTime(_vm.systemStats.timestamp)))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("CPU Usage")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.systemStats.cpu.usage.toFixed(2)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-bar"
  }, [_c('div', {
    staticClass: "stat-bar-fill",
    style: ({
      width: _vm.systemStats.cpu.usage + '%',
      backgroundColor: _vm.getUsageColor(_vm.systemStats.cpu.usage)
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("CPU Model")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.cpu.model))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("CPU Cores")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.cpu.cores))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Load Average (1min)")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.cpu.loadAverage.avg1min.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Load Average (5min)")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.cpu.loadAverage.avg5min.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Load Average (15min)")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.cpu.loadAverage.avg15min.toFixed(2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("Memory Information")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Memory Usage")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.systemStats.memory.usagePercentage.toFixed(2)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-bar"
  }, [_c('div', {
    staticClass: "stat-bar-fill",
    style: ({
      width: _vm.systemStats.memory.usagePercentage + '%',
      backgroundColor: _vm.getUsageColor(_vm.systemStats.memory.usagePercentage)
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Total Memory")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.memory.totalFormatted))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Used Memory")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.memory.usedFormatted))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Free Memory")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value-small"
  }, [_vm._v(_vm._s(_vm.systemStats.memory.freeFormatted))])])])]), _vm._v(" "), _c('div', {
    staticClass: "stats-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', [_vm._v("PM2 Processes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "disabled": _vm.restarting
    },
    on: {
      "click": _vm.confirmRestartPM2
    }
  }, [_vm._v("\n          " + _vm._s(_vm.restarting ? 'Restarting...' : 'Restart PM2') + "\n        ")])]), _vm._v(" "), (_vm.systemStats.pm2 && _vm.systemStats.pm2.length > 0) ? _c('div', [_c('table', {
    staticClass: "pm2-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("CPU %")]), _vm._v(" "), _c('th', [_vm._v("Memory")]), _vm._v(" "), _c('th', [_vm._v("Uptime")]), _vm._v(" "), _c('th', [_vm._v("Restarts")]), _vm._v(" "), _c('th', [_vm._v("PID")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.systemStats.pm2), function(process) {
    return _c('tr', {
      key: process.pmId || process.pid
    }, [_c('td', [_vm._v(_vm._s(process.name))]), _vm._v(" "), _c('td', [_c('span', {
      class: 'status-badge status-' + process.status.toLowerCase()
    }, [_vm._v("\n                  " + _vm._s(process.status) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(process.cpu.toFixed(2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(process.memoryFormatted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(process.uptimeFormatted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(process.restarts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(process.pid || 'N/A'))])])
  }), 0)])]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "2rem",
      "color": "#666"
    }
  }, [_c('p', [_vm._v("No PM2 processes found")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2rem",
      "color": "#666",
      "font-size": "12px"
    }
  }, [_c('p', [_vm._v("Auto-refreshing every " + _vm._s(_vm.refreshInterval / 1000) + " seconds")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--secondary",
    staticStyle: {
      "margin-top": "0.5rem"
    },
    on: {
      "click": _vm.toggleAutoRefresh
    }
  }, [_vm._v("\n        " + _vm._s(_vm.autoRefreshEnabled ? 'Disable' : 'Enable') + " Auto-refresh\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c8943b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/SystemSettings.vue
// module id = 1679
// module chunks = 2